import React from 'react';
import Navbar from './Navbar';
import Logo from "../logo.svg";
import { IoCartOutline } from 'react-icons/io5';
import { RiArrowDropDownLine } from "react-icons/ri";
import { FaSearch } from "react-icons/fa";
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { logout } from '../redux/features/authSlice';
import { LOGIN_ROUTE } from '../Routes';



const Header = () => {
    const {t, i18n} = useTranslation();
    const dispatch = useDispatch();
    const changeLang = (lang) =>{
        i18n.changeLanguage(lang)
    }
    const {items} = useSelector((state) => state.cart)
    const {isAuth} = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const handleLogout = () => {
        dispatch(logout())
        navigate(LOGIN_ROUTE)
    }
  
  return (
    <>
    <header className='headerApp'>
    <div className="w-full bg-white h-10 border-b border-qgray-border quomodo-shop-top-bar">
        <div className="container mx-auto h-full">
            <div className="flex justify-end items-center h-full">
                <div className="topbar-dropdowns sm:block hidden">
                    <div className="flex space-x-6">
                    
                        <div className="language-select flex space-x-1 items-center">
                        <div className="group relative">
                        <button className="py-2 px-4 inline-flex items-center">
                        <span className="mr-1">{t('welcome')}</span>
                        <RiArrowDropDownLine size={30} />
                        </button>
                        <div tabIndex="0" className="border border-1 bg-white invisible border-gray-800  w-60 absolute left-0 top-full transition-all opacity-0 group-focus-within:visible group-focus-within:opacity-100 group-focus-within:translate-y-1">
                            <ul className="py-1">
                                <li>
                                    <button className="block px-4 py-2 hover:bg-gray-100" onClick={() =>changeLang('fr')}>
                                    Fr
                                    </button>
                                </li>
                                <li>
                                    <button  className="block px-4 py-2 hover:bg-gray-100" onClick={() =>changeLang('en')}>
                                    En
                                    </button>
                                </li>
                            
                            </ul>
                        </div>
                    </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
        <div className='container mx-auto flex justify-between items-center p-2'>
            <a href="?"><img src={Logo} alt="shop" width={70} /></a>
            <div className="SearchBar">
                <form action="">
                    <div className="relative w-full">
                        <input type="search" id="search-dropdown" className="block w-80 p-2.5 z-20 text-sm text-gray-900 bg-gray-50  border border-s-2 border border-gray-300 focus:border-gray-300 focus:outline-none dark:bg-gray-700 dark:border-s-gray-700  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-blue-500" placeholder="Search product..." required />
                        <button type="submit" className="absolute top-0 end-0 p-2.5 text-sm font-medium h-full text-white bg-primaryColor border border-primaryColor  focus:ring-0 focus:outline-none focus:ring-blue-300">
                            <FaSearch />
                            <span className="sr-only">Search</span>
                        </button>
                    </div>
                </form>
                </div>
                <div className='flex justify-end items-center'>
                    <div className="Cart flex">
                        <Link to="/cart"> <IoCartOutline size={30} /></Link>
                        
                           <span>{items.length > 0 && items.length}</span> 
                    </div>
                    <div className="Singup pl-2">
                        {isAuth? <> <Link to="/user/dashboard" >Dashboard</Link> | <button onClick={handleLogout}>Logout</button></> : 
                            <>
                                <Link to="/register" >Register</Link>
                                <span> | </span>
                                <Link to="/login" >Login</Link>
                            </>
                        }
                    </div>
                </div>
           
        </div>        

    </header>
    <Navbar />
    </>
  )
}

export default Header